module.exports = __webpack_public_path__ + "img/ErnestRutherford.786f8b39.jpg";